export default __webpack_public_path__ + "static/media/Diviner's Leggings of the Kingmaker.e9cf3b5b.jpg";